import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95b641f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "steps-box" }
const _hoisted_3 = { class: "item-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tail" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "product-list-box" }
const _hoisted_10 = { class: "statistics-box" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, " $ 389.00 ", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, " $ 389.00 ", -1))
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value actual-payment" }, " $ 389.00 ", -1))
const _hoisted_20 = { class: "order-info-box" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, " 12345924752112 ", -1))
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, " Delivery monthly；04-01/05-01... ", -1))

import { ref, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import OrderProductItem from './components/order-product-item.vue';

  interface Step {
    title: string,
    description?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const curStep = ref<number>(0);
  const stepList = ref<Step[]>([]);

  onMounted(() => {
    stepList.value = [
      {
        title: 'Shipped',
      },
      {
        title: 'To',
        description: 'Edward Chan，Tianhe District, Guangzhou，Room 1110 Poly Clovis Plaza, #9，New York，NY10001，United Stated'
      }
    ];
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.title,
          class: _normalizeClass(["item", { finished: index === curStep.value }])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.description), 1)
            ])
          ])
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
        return _createVNode(OrderProductItem, { key: item })
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('Subtotal')), 1),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('Discount')), 1),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('Actual payment')), 1),
        _hoisted_19
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('Order Information')), 1),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('Order number')), 1),
        _hoisted_24
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('Delivery Frequency')), 1),
        _hoisted_27
      ])
    ])
  ]))
}
}

})